import { BaseEntity } from '../base-entity';

export class FormHumidityFilter extends BaseEntity {
    hibrido: string;
    safra: string;
    padrao_percentil: string;
    umidade_maxima: string;
}
